import { insurance } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function find({ url: { service }, token }: IAPI) {
  return async function find(params: insurance.GetInsuranceParams) {
    const url = new URL(`/insurance`, service);
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined) {
        url.searchParams.set(key, value);
      }
    }

    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    if (!response.ok) {
      throw new Error(`Network response was not OK: ${response.status}`);
    }
    return (await response.json()) as insurance.Insurance[];
  };
}

export function terminateInsurance({ url: { service: baseURL }, token }: IAPI) {
  return async function terminateInsurance(
    params: insurance.InsuranceTerminateParams
  ) {
    const { id, reason, at } = params;
    const data: insurance.TerminateRequest = { Reason: reason };
    if (at) data.TerminatedAt = at.toISOString();
    const url = new URL(`/insurance/${id}/terminate`, baseURL);
    const response = await fetch(url, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(`Network response was not OK: ${response.status}`);
    }
    return (await response.json()) as insurance.Insurance;
  };
}

export function patchInsurance({ url: { service: baseURL }, token }: IAPI) {
  return async function patchInsurance(
    insurance: insurance.Insurance
  ): Promise<insurance.Insurance> {
    const url = new URL(`/insurance/${insurance.ID}`, baseURL);
    const response = await fetch(url, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(insurance),
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.json();
  };
}
